import { string } from "prop-types";

import { Popover, PopoverContent, PopoverTrigger } from "../../../../shared/v2/Popover";
import ListOlRegularV6 from "../../../../shared/v2/Icomoon/Icons/ListOlRegularV6";

const TaskInstructions = ({ instructions }) => (
  <Popover placement="bottom-start" maxHeight={196}>
    <PopoverTrigger>
      <button
        type="button"
        aria-label="Show instructions"
        className="tw-flex tw-shrink-0 tw-items-end tw-p-[2px] tw-rounded-[4px] tw-border-0 tw-bg-transparent tw-cursor-pointer tw-text-theme-brand hover:tw-text-theme-text-button-color-hover data-[state=open]:tw-text-theme-text-button-color-hover data-[state=open]:tw-bg-[var(--brand-lightest)]"
      >
        <ListOlRegularV6 size="l" />
      </button>
    </PopoverTrigger>
    <PopoverContent className="tw-w-[317px] tw-p-16px tw-gap-[4px] !tw-rounded-[8px] tw-border tw-border-solid tw-border-neutral-gray-10">
      <div className="tw-text-12px tw-leading-[16px] tw-font-semibold tw-text-neutral-gray-75">
        Instructions
      </div>
      <div className="tw-text-14px tw-leading-[20px] tw-text-neutral-gray-75 tw-whitespace-pre-wrap tw-break-words">
        {instructions}
      </div>
    </PopoverContent>
  </Popover>
);

TaskInstructions.propTypes = {
  instructions: string.isRequired,
};

export default TaskInstructions;
